export default "__VITE_ASSET__CI8gfzSm__"